import type { MeetingData } from '@/app/queries/MeetingQuery/context';

export type ReleaseCall = () => void;

const NOTHING_TO_RELEASE: ReleaseCall = () => undefined;

export const callHoldNameFor = ({ meeting_data: meeting }: MeetingData) =>
  `onsite-call:${meeting.channel_name}:${meeting.user_id}`;

const lockManagerOf = (browser: Partial<Pick<Navigator, 'locks'>>) => browser.locks;

const requestHold = (locks: LockManager, name: string) => new Promise<ReleaseCall | null>((settle, fail) => {
  const grant = (lock: Lock | null) => {
    if (!lock) {
      settle(null);
      return Promise.resolve();
    }

    return new Promise<void>((release) => settle(() => release()));
  };

  locks.request(name, { ifAvailable: true }, grant).catch(fail);
});

export const holdCall = (name: string): Promise<ReleaseCall | null> => {
  const locks = lockManagerOf(navigator);
  if (!locks) {
    return Promise.resolve(NOTHING_TO_RELEASE);
  }

  return requestHold(locks, name).catch(() => NOTHING_TO_RELEASE);
};

export const isCallHeld = (name: string): Promise<boolean> => {
  const locks = lockManagerOf(navigator);
  if (!locks) {
    return Promise.resolve(false);
  }

  return locks.query().then(
    ({ held = [] }) => held.some((lock) => lock.name === name),
    () => false,
  );
};
